import React, { Component } from "react";
import styles from "./Page.css";
import { TypeRoute } from "../constants/consts-prop-types";
import { Helmet } from "react-helmet";
import Header from "../components/Header/Header";
import Menu from "../components/Menu/Menu";
import Search from "../components/Search/Search";
import Footer from "../components/Footer/Footer";
// import Cookies from '../components/Cookies/Cookies';
import NewsletterPopUp from "../components/NewsletterPopUp/NewsletterPopUp";
import {
  colorsDefault,
  colorsDefaultInverted,
} from "../services/service-color-inverter";
import { getPageData } from "../services/service-wp";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import Contents from "../components/Contents/Contents";
import NotFound from "./notfound/NotFound";
import { setLIB } from "../constants/consts-types";
import InfoScreenViewer from "../components/InfoScreenViewer/InfoScreenViewer";
import NotificationBar from "../components/NotificationBar/NotificationBar";
import { decodeHtmlSpecialChars } from "../services/service-decode-html-special-chars";
import { analyticsPageView } from "../services/service-analytics";
import { getUrlParams } from "../services/service-url-search-params";
import {
  isSMKGuide,
  isExternalLink,
  getPathFromAbsoluteUrl,
} from "../services/service-utils";

class Page extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
  };

  constructor(props) {
    super(props);

    const initialInlinePageData = window.smkPageData
      ? this.addDefaultsToApiData(window.smkPageData)
      : null;
    console.log("initialInlinePageData", initialInlinePageData);

    if (initialInlinePageData && initialInlinePageData.i18n) {
      setLIB(Object.freeze(initialInlinePageData.i18n));
    }

    this.state = {
      currentRoute: initialInlinePageData,
      loadingData: false,
      menuOpen: false,
      searchOpen: false,
      activateNewsletter: false,
      clicks: 0,
    };

    this.menuToggle = this.menuToggle.bind(this);
    this.searchOpen = this.searchOpen.bind(this);
  }

  componentDidMount() {
    if (!window.smkPageData) this.onRouteChanged();

    document.addEventListener("click", this.incrementClicks);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.incrementClicks);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      // prevent loading pageData when opening/closing modal:
      // when opening modal:
      if (
        this.props.location.search.includes("modal") &&
        !prevProps.location.search.includes("modal")
      )
        return;
      // when closing modal:
      if (
        !this.props.location.search.includes("modal") &&
        prevProps.location.search.includes("modal")
      )
        return;

      this.onRouteChanged(prevProps);
    }
  }

  incrementClicks = () => {
    this.setState((prev) => ({
      clicks: ++prev.clicks,
    }));
  };

  addDefaultsToApiData(routeData) {
    let heroColors = null;
    if (routeData && routeData.components && routeData.components.length > 0) {
      const firstComponent = routeData.components[0];
      if (firstComponent.colors && firstComponent.colors.foreground) {
        heroColors = {
          foreground: firstComponent.colors.foreground,
          background: firstComponent.colors.background,
        };
      }

      if (firstComponent.component_id === "featured_items") {
        heroColors = colorsDefaultInverted;
      }
    }

    const hardCodedDefaultProperties = {
      colors: routeData && routeData.colors ? routeData.colors : colorsDefault,
      heroColors: heroColors,
    };
    return { ...routeData, ...hardCodedDefaultProperties };
  }

  async loadData(prevProps, pathname, urlParams) {
    if (prevProps && pathname !== prevProps.location.pathname) {
      this.setState({
        loadingData: true,
      });
    }

    // load page data via API:
    const routeData = await getPageData(pathname, urlParams);

    if (!routeData) {
      console.error("Error: The data for this page could not be loaded");
      return;
    }

    // prevents weird (encoded) characters from showing up in page-titles:
    const pageTitle = routeData.site_data
      ? decodeHtmlSpecialChars(routeData.site_data.site_title)
      : "";

    analyticsPageView(pageTitle, pathname, routeData);

    // put library with translated texts (i18n) from data into an importable const LIB:
    if (routeData.i18n) setLIB(Object.freeze(routeData.i18n));

    const modifiedRouteData = this.addDefaultsToApiData(routeData);
    console.log("routeData", modifiedRouteData);

    this.setState({
      loadingData: false,
      currentRoute: modifiedRouteData,
      menuOpen: false,
      searchOpen: false,
      pageTitle: pageTitle,
      activateNewsletter: false,
    });
  }

  onRouteChanged(prevProps) {
    const { pathname, search } = this.props.location;
    console.log("onRouteChanged", this.props.location.pathname);
    this.loadData(prevProps, pathname, search);
  }

  searchOpen() {
    this.setState({
      searchOpen: true,
      menuOpen: false,
    });
  }

  menuToggle() {
    this.setState((prevState) => {
      if (prevState.searchOpen) {
        return {
          searchOpen: false,
        };
      } else {
        return {
          activeMenuIndex: undefined,
          menuOpen: !prevState.menuOpen,
          searchOpen: false,
        };
      }
    });
  }

  footerCallback = (childData) => {
    this.setState({ activateNewsletter: childData });
  };

  newsletterCallback = (childData) => {
    console.log("childData: ", childData);
    if (!childData) {
      this.setState({ activateNewsletter: false });
    }
  };

  guideMenu = () => {
    const { currentRoute = {} } = this.state;
    const { menu = [] } = currentRoute.smk_guide || {};
    const activeMenuItems = menu
      ? menu.filter((item = {}) => item.guide_menu_active_menu)
      : [];
    return activeMenuItems.map((menuItem) => {
      let { url } = menuItem.guide_menu_link;
      url = isExternalLink(url) ? url : getPathFromAbsoluteUrl(url);

      return {
        title: menuItem.guide_menu_link.title,
        url,
        featured: true,
        external: isExternalLink(url),
      };
    });
  };

  render() {
    const { search } = this.props.location;

    const {
      currentRoute,
      pageTitle,
      loadingData,
      menuOpen,
      searchOpen,
      activeMenuIndex,
    } = this.state;

    if (!currentRoute) return null;
    if (currentRoute && !currentRoute.id)
      return <NotFound currentRoute={currentRoute} />;

    const pageStyle = {
      height: menuOpen || searchOpen ? "100vh" : "auto",
      color: currentRoute.colors.foreground,
      backgroundColor: currentRoute.colors.background,
      position: "relative", // In order for notification bar to work properly
    };

    const mainStyle = {
      opacity: loadingData ? 0 : 1,
    };

    // detect if url has search-param marked for the SMK entrance screens:
    const showPageAsInfoScreen = getUrlParams(search).view === "info";

    const isGuide = isSMKGuide(currentRoute);

    const menu = isGuide ? this.guideMenu() : currentRoute.menu;
    const mainCss = `${styles.main}${isGuide ? ` ${styles.Guide}` || "" : ""}`;

    const setActiveMenuIndex = (idx) => {
      this.setState({
        activeMenuIndex: idx,
        searchOpen: false,
        menuOpen: typeof idx === "number",
      });
    };

    const isThy = currentRoute.site_data.home_url.includes("thy");

    return (
      <ScrollToTop currentRoute={currentRoute}>
        <a className={styles.skipContent} href="#main">
          Skip to main content
        </a>
        {/* NotificationBar disabled on infoscreen on req. of SMK. I think it might make a comeback at one point */}
        {currentRoute.notificationbar.message && !showPageAsInfoScreen && (
          <NotificationBar
            message={currentRoute.notificationbar.message}
            hash={currentRoute.notificationbar.hash}
            showPageAsInfoScreen={showPageAsInfoScreen}
          />
        )}
        <div className={styles.Page} style={pageStyle}>
          {currentRoute &&
          currentRoute.site_data &&
          currentRoute.site_data.site_title ? (
            <Helmet encodeSpecialCharacters={true}>
              <title>{pageTitle}</title>
            </Helmet>
          ) : (
            <Helmet>
              <title>{currentRoute.message}</title>
            </Helmet>
          )}

          {!showPageAsInfoScreen && (
            <React.Fragment>
              <Header
                currentRoute={currentRoute}
                onMenuToggle={this.menuToggle}
                onSearchToggle={this.searchOpen}
                menuOpen={menuOpen}
                searchOpen={searchOpen}
                activeMenuIndex={activeMenuIndex}
                setActiveMenuIndex={setActiveMenuIndex}
                isThy={isThy}
              />
              <Menu
                menuOpen={menuOpen}
                routes={menu}
                currentRoute={currentRoute}
                onMenuToggle={this.menuToggle}
                onSearchToggle={this.searchOpen}
                searchOpen={searchOpen}
                isThy={isThy}
              />
              <Search
                searchOpen={searchOpen}
                searchUrl={currentRoute.site_data.search_url}
                langCode={currentRoute.language}
                opening_hours={currentRoute.opening_hours}
                menuOpen={menuOpen}
                routes={menu}
                currentRoute={currentRoute}
                onMenuToggle={this.menuToggle}
                onSearchToggle={this.searchOpen}
              />
            </React.Fragment>
          )}

          <main id="main" className={mainCss} style={mainStyle}>
            {!showPageAsInfoScreen && <Contents currentRoute={currentRoute} />}

            {showPageAsInfoScreen && (
              <InfoScreenViewer currentRoute={currentRoute} />
            )}
          </main>

          {!showPageAsInfoScreen && (
            <React.Fragment>
              <Footer
                data={currentRoute.footer}
                theme={currentRoute.footer_color}
                newsletter={this.footerCallback}
                section={currentRoute.section && currentRoute.section.name}
                isThy={isThy}
              />
              {/* <Cookies data={currentRoute.cookie_box} /> */}
            </React.Fragment>
          )}
          {this.state.clicks >= 10000 && (
            <NewsletterPopUp
              data={currentRoute.cookie_box}
              newsletter={this.state.activateNewsletter}
              closeNewsletter={this.newsletterCallback}
            />
          )}
        </div>
      </ScrollToTop>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/templates/Page.js